import { ForemanArea } from './ForemanArea';
import { Activity } from './Activity';
import { Asset } from './Asset';
import { Project } from './Project';
import { ContractArea } from './ContractArea';
import { Effort } from './Effort';
import { TaskHistory } from './Task';

export enum TaskStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum TaskSubType {
  Numbered_NonNumbered = 'Numbered Task',
}

// Display text mapping for user-friendly dropdown
export const TaskSubTypeDisplayText = {
  [TaskSubType.Numbered_NonNumbered]: 'Requires automated separation of Numbered and Non-Numbered Roads'
};

export interface QuantifiedTask {
  id: number;
  taskId: number;
  identifiedQuantity: number;
  unitOfMeasure: string;
}

export interface TaskLocation {
  id: number;
  taskId: number;
  type: 'START' | 'END';
  latitude: number;
  longitude: number;
  assetId?: number;
  asset?: Asset | null;
}

export interface TaskAttachment {
  id?: number;
  taskId: number;
  attachmentURL: string;
  attachmentNotes?: string;
  attachmentName: string;
  attachmentType?: string;
}

// Flattened structure that directly matches the API response
export interface RoutineTask {
  id: number;
  taskId: number;
  taskNumber?: string;
  type: string;
  mode?: string;
  priority?: string;
  name?: string;
  description: string;
  status: string;
  foremanAreaId?: number | null;
  foremanArea?: ForemanArea;
  projectId?: number | null;
  project?: Project;
  completionAccomplishment?: number;
  internalNotes?: string;
  instructions?: string;
  contractAreaId?: number;
  contractArea?: ContractArea;
  clonedTaskId?: number | null;
  createdAt?: string;
  startDate?: string;
  completionDate?: string;
  identifiedDate?: string;
  
  // Collection arrays
  activities?: Activity[];
  taskLocations?: TaskLocation[];
  efforts?: Effort[];
  quantifiedTasks?: QuantifiedTask[];
  taskAttachments?: TaskAttachment[];
  taskHistory?: TaskHistory[];
  workIdId?: number | null;
  assignedEmployees?: import('./User').User[];

  // Routine task allocations
  labourAllocation: number;
  materialAllocation: number;
  equipmentAllocation: number;
  secondaryLabourAllocation?: number;
  secondaryMaterialAllocation?: number;
  secondaryEquipmentAllocation?: number;
  taskSubType?: TaskSubType;
}

export interface CreateProjectRoutineTask {
  description: string;
  name?: string;
  projectId?: number;
  activities: number[];
  status: string;
  mode: 'specific';
  internalNotes?: string;
  instructions?: string;
  foremanAreaId?: number;
  priority?: string;
  contractAreaId?: number;
  taskLocations?: Array<{
    type: 'START' | 'END';
    latitude: number;
    longitude: number;
    assetId?: number;
  }>;
  taskSubType?: TaskSubType;
  labourAllocation?: number;
  materialAllocation?: number;
  equipmentAllocation?: number;
  secondaryLabourAllocation?: number | null;
  secondaryMaterialAllocation?: number | null;
  secondaryEquipmentAllocation?: number | null;
  clonedTaskId?: number | null;
  completionAccomplishment?: number;
  startDate?: string;
  completionDate?: string;
  assignedEmployeeIds?: number[];
}